module.exports = __webpack_public_path__ + "img/user-group.d30b9838.svg";